// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cp-parentnode select+select,\n.cp-parentnode input[type=\"text\"]+input[type=\"text\"] {\n  margin-top: 5px !important;\n  margin-left: 0px !important;\n}\n", ""]);
// Exports
module.exports = exports;
